import { render } from "./static-page-create-import.vue?vue&type=template&id=2a7ba471"
import script from "./static-page-create-import.vue?vue&type=script&lang=js"
export * from "./static-page-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__